import { IGetTaxDataFormatted } from '@api/types';

type TaxDataResponse = IGetTaxDataFormatted | IGetTaxDataFormatted[] | null | undefined;

const normalizeTaxData = (taxData: TaxDataResponse): IGetTaxDataFormatted | null => {
    if (Array.isArray(taxData)) return taxData[0] ?? null;
    return taxData ?? null;
};

export default normalizeTaxData;
